import getStore from '../store/store';
import SuggestedRepliesOptionState from '../store/schema/SuggestedRepliesOptionState';
import { discardAction } from '../actions/suggestedRepliesOptionActions';
import { mutator } from 'satcheljs';

export default mutator(discardAction, () => {
    // User has chosen to discard changes they made to the option state.
    // Clear the store, no need to update backend.
    const optionState: SuggestedRepliesOptionState = getStore();
    optionState.isEnabled = null;
});
